import { Component } from '@angular/core';
import { LoaderService } from '@bst-frontend/shared';

@Component({
  selector: 'bst-frontend-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
})
export class LoaderComponent {
  constructor(public loader: LoaderService) {}
}
